<app-pcbread-crumb [data]="'Buy,Factor'"></app-pcbread-crumb>

<div
  id="addCard"
  class="card mb-4 stock-card animate__animated animate__backInDown"
  *ngIf="level < 3 && level != 0"
>
  <div class="card-body p-0">
    <div class="row m-0">
      <div class="col-sm-3 order-sm-1 col-6 order-1 p-0">
        <p class="p-2 m-0">{{ "Factor" | translate }}</p>
      </div>
      <div
        class="col-sm-3 order-sm-3 col-6 order-2 d-flex justify-content-sm-end align-content-sm-start align-items-sm-start justify-content-end align-content-center align-items-center p-0"
      >
        <div class="p-2">
          <button
            type="button"
            class="btn btn-icon btn-outline-primary me-1"
            placement="bottom"
            (click)="SaveBuyFactorEditable()"
            ngbTooltip="{{ 'Save' | translate }}"
            id="print.id"
          >
            <span class="tf-icons bx bx-save"></span>
          </button>

          <button
            type="button"
            class="btn btn-icon btn-outline-primary me-1"
            placement="bottom"
            (click)="parentAction(settingModal)"
            ngbTooltip="{{ 'Settings' | translate }}"
          >
            <span class="bx bx-cog"></span>
          </button>
          <button
            type="button"
            class="btn btn-icon btn-outline-primary"
            placement="bottom"
            (click)="openPreInvoice()"
            ngbTooltip="{{ 'ImportPreInvoice' | translate }}"
          >
            <span class="tf-icons bx bxs-file-import"></span>
          </button>

          <button
            type="button"
            class="btn btn-icon btn-outline-primary ms-1"
            placement="bottom"
            (click)="router.navigate(['/FactorList'])"
            ngbTooltip="{{ 'List' | translate }}"
          >
            <span class="tf-icons bx bx-list-check"></span>
          </button>
          <button
            type="button"
            class="btn btn-icon btn-outline-primary ms-1"
            placement="bottom"
            (click)="saveBuyFactor()"
            ngbTooltip="{{ 'FinalSubmit' | translate }}"
            id="print.id"
          >
            <span class="tf-icons bx bx-check-double"></span>
          </button>
        </div>
      </div>
      <div
        class="col-sm-6 order-sm-2 col-12 mt-1 order-2 d-flex justify-content-sm-center align-content-sm-start align-items-sm-center justify-content-center align-content-center align-items-center"
      >
        <div class="total-box">
          <span class="p-2">
            {{ "SumTotal" | translate }} :
            {{ backendJson.totalPrice | dataType : "price" }}
          </span>
        </div>
      </div>
    </div>

    <div class="row p-1 m-0">
      <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
        <label for="companyName" class="form-label m-0"
          >{{ "Company" | translate }}:</label
        >
        <div class="validation-alert-sale-buy" id="CompanyName">
          <p>{{ backendJson.drugDistributorIdMessage }}</p>
        </div>
        <app-drop-down
          [dropDownData]="companyList"
          [fieldName]="['Title']"
          [addUrl]="'DrugDistributor'"
          [defaultValue]="this.backendJson.drugDistributorId"
          [isValid]="
            backendJson.drugDistributorIdMessage == '' ||
            backendJson.drugDistributorIdMessage == null
          "
          [buttonClass]="'Focusable'"
          (ngModelValueChange)="changeCompany($event)"
        ></app-drop-down>
      </div>
      <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
        <label for="organizationname" class="form-label m-0"
          >{{ "FactorId" | translate }}:</label
        >
        <div class="validation-alert-sale-buy">
          <p>{{ backendJson.factorIdMessage }}</p>
        </div>
        <input
          id="FactorId"
          type="text"
          autocomplete="off"
          class="form-control Focusable"
          [ngClass]="{
            'is-invalid':
              backendJson.factorIdMessage != '' &&
              backendJson.factorIdMessage != null
          }"
          appSelectOnFocus
          [(ngModel)]="backendJson.factorId"
          [ngModelOptions]="{ standalone: true }"
          placeholder="{{ 'FactorId' | translate }}"
        />
      </div>
      <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
        <label for="factorDate" class="form-label m-0"
          >{{ "factorDate" | translate }}:</label
        >
        <div class="validation-alert-sale-buy">
          <p>{{ backendJson.factorDateMessage }}</p>
        </div>
        <div class="datepicker-box">
          <input
            id="factorDate"
            type="text"
            class="form-control Focusable"
            autocomplete="off"
            [ngClass]="{
              'is-invalid':
                backendJson.factorDateMessage != '' &&
                backendJson.factorDateMessage != null
            }"
            appSelectOnFocus
            appConvertNumbers
            [ngModel]="backendJson.factorDate | dataType : '' : false"
            [ngModelOptions]="{ standalone: true }"
            placeholder="YYYY/MM/DD"
            (ngModelChange)="backendJson.factorDate = calendarService.TypeDate('factorDate')"
          />
          <button
            [ngbPopover]="popoverDatapickerfactorDate"
            [autoClose]="'outside'"
            #datePicker="ngbPopover"
          >
            <i class="far fa-calendar-alt"></i>
          </button>
        </div>
        <ng-template #popoverDatapickerfactorDate>
          <app-data-picker
            [(childProp)]="backendJson.factorDate"
            (changeVariableMonth)="changeMonth($event)"
          ></app-data-picker>
        </ng-template>
      </div>
      <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
        <label for="RecivedDate" class="form-label m-0"
          >{{ "DeliveryData" | translate }}:</label
        >
        <div class="validation-alert-sale-buy">
          <p>{{ backendJson.DeliveryDataMessage }}</p>
        </div>
        <div class="datepicker-box">
          <input
            type="text"
            class="form-control Focusable"
            autocomplete="off"
            [ngClass]="{
              'is-invalid':
                backendJson.DeliveryDataMessage != '' &&
                backendJson.DeliveryDataMessage != null
            }"
            id="RecivedDate"
            appSelectOnFocus
            appConvertNumbers
            [ngModel]="backendJson.deliveryDate | dataType : '' : false"
            [ngModelOptions]="{ standalone: true }"
            placeholder="YYYY/MM/DD"
            (ngModelChange)="backendJson.deliveryDate = calendarService.TypeDate('RecivedDate')"
          />
          <button
            [ngbPopover]="popoverDatapickerdeliverydata"
            [autoClose]="'outside'"
            #datePicker="ngbPopover"
          >
            <i class="far fa-calendar-alt"></i>
          </button>
        </div>
        <ng-template #popoverDatapickerdeliverydata>
          <app-data-picker
            [(childProp)]="backendJson.deliveryDate"
            (changeVariableMonth)="changeMonth($event)"
          ></app-data-picker>
        </ng-template>
      </div>
      <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
        <div class="edit-form">
          <div class="m-0 p-0">
            <label class="form-label" for="buyDiscount">
              {{ "BuyDiscount" | translate }} :
            </label>
          </div>
          <input
            id="buyDiscount"
            type="text"
            autocomplete="off"
            class="form-control set-input Focusable"
            autocomplete="off"
            appSelectOnFocus
            [(ngModel)]="backendJson.discount"
            mask="separator.0"
            thousandSeparator=","
            (keyup)="totalFactorPrice()"
          />
          <span class="set-position-rial-prefix">
            {{ "Rial" | translate }}
          </span>
        </div>
      </div>
      <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
        <div class="m-0 p-0">
          <label for="Seller" class="form-label">
            {{ "seller" | translate }}:
          </label>
        </div>
        <div class="validation-alert-sale-buy" id="visitor">
          <p>{{ backendJson.sellerIdMessage }}</p>
        </div>
        <app-drop-down
          [relationId]="backendJson.drugDistributorId"
          [relationName]="'drugDistributorId'"
          [defaultValue]="this.backendJson.sellerId"
          [dropDownData]="sellerList"
          [fieldName]="['firstName', 'lastName']"
          [addUrl]="'Seller'"
          [isDisable]="backendJson.drugDistributorId == null"
          [buttonClass]="'Focusable'"
          (ngModelValueChange)="backendJson.sellerId = $event.id"
        ></app-drop-down>
      </div>
      <div class="col-12 col-lg-6 col-md-12 top-input-box mt-3">
        <div class="m-0 ps-3">
          <label class="form-label" for="FactorFile" id="UploadFile">
            {{ "FactorFile" | translate }} :
          </label>
        </div>
        <app-file-drop
          class="m-0 form-control dropdown-list"
          [shortLink]="currentFile"
          (childEvent)="currentFile = $event"
        ></app-file-drop>
      </div>
      <div class="col-12 top-input-box mt-3">
        <label for="description" class="form-label m-0"
          >{{ "description" | translate }}:</label
        >
        <textarea
          id="description"
          type="text"
          class="form-control Focusable"
          placeholder="{{ 'description' | translate }}"
          [(ngModel)]="backendJson.description"
        >
        </textarea>
      </div>
    </div>
    <div class="row p-1 m-0 drug-list" style="width: 100%">
      <div class="mvc-grid-table">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th scope="col">{{ "Row" | translate }}</th>
              <th scope="col">{{ "ProductBrandName" | translate }}</th>
              <th scope="col">{{ "Number" | translate }}</th>
              <th scope="col">{{ "expireDate" | translate }}</th>
              <th scope="col">{{ "buyPrice" | translate }}</th>
              <th scope="col">{{ "buyDiscount" | translate }}</th>
              <th scope="col">{{ "TotalAmount" | translate }}</th>
              <th scope="col">{{ " " | translate }}</th>
            </tr>
          </thead>
          <tbody id="rows">
            <tr *ngFor="let selectDrug of backendJson.drugs; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ selectDrug.drugName }}</td>
              <td>{{ selectDrug.packageCount | dataType : "" }}</td>
              <td>{{ selectDrug.expireDate | dataType : "" }}</td>
              <td>
                {{ selectDrug.buyPrice | dataType : "price" }}
              </td>
              <td>
                {{ selectDrug.buyDiscount | dataType : "price" }}
              </td>
              <td>
                {{ selectDrug.totalPrice | dataType : "price" }}
              </td>
              <div class="button-box-buy-factor">
                <button
                  type="button"
                  class="btn btn-icon btn-outline-primary"
                  (click)="editItem(i, selectDrug)"
                >
                  <i class="far fa-edit"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-icon btn-outline-danger ms-1"
                  (click)="remove(i)"
                >
                  <i class="fa-regular fa-trash-can"></i>
                </button>
              </div>
            </tr>
          </tbody>
        </table>
        <div id="add-box" class="row add-box-item mt-2">
          <div class="col-12 my-2">
            <div class="total-box">
              <span class="p-2">
                {{ "Sum" | translate }} :
                {{ editableItem.totalPrice | dataType : "price" }}
              </span>
            </div>
          </div>
          <div
            class="col-12 col-xxl-4 col-xl-4 col-lg-12 col-md-12 mb-2 padding-mobile-size"
          >
            <div class="row input-box drug-information-box ms-1 p-2">
              <div class="col-12 mb-3">
                <div class="input-box-title-box px-2">
                  <span>{{ "DrugInformation" | translate : "" }}</span>
                </div>
                <div
                  class="edit-form search-input-box"
                  appClickOutside
                  (clickOutside)="modalIsOpen = false"
                >
                  <div class="validation-alert-sale-buy">
                    <p>{{ editableItemMessage.drugName }}</p>
                  </div>
                  <label class="form-label" for="drugBrandName">
                    {{ "ProductBrandName" | translate }}
                  </label>

                  <form [formGroup]="drugSearchForm">
                    <div
                      class="input-group input-box-search-advance row ms-1 p-0 w-100"
                    >
                      <div class="col-3 p-0">
                        <input
                          id="drugGenericCode"
                          type="text"
                          autocomplete="off"
                          class="form-control Focusable iner-Focusable search-input-box"
                          placeholder="{{ 'genericCode' | translate }}"
                          appSelectOnFocus
                          [(ngModel)]="editableItem.drugGenericCode"
                          [ngModelOptions]="{ standalone: true }"
                          (keyup.Enter)="searchWithGenericCode()"
                          (keyup.escape)="modalIsOpen = false"
                        />
                      </div>
                      <div class="col-xxl-7 col-xl-9 col-7 p-0">
                        <input
                          id="drugBrandName"
                          type="text"
                          autocomplete="off"
                          appSelectOnFocus
                          formControlName="drugBrandName"
                          class="form-control Focusable iner-Focusable search-input-box"
                          placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                          [(ngModel)]="editableItem.drugName"
                          [ngClass]="{
                            'is-invalid':
                              editableItemMessage.drugName != '' &&
                              editableItemMessage.drugName != null
                          }"
                          (keyup.escape)="modalIsOpen = false"
                        />
                      </div>

                      <div class="col-xxl-1 col-xl-6 col-1 p-0">
                        <button
                          class="btn btn-outline-primary w-100 px-0"
                          type="button"
                          ngbTooltip="{{ 'ScanBarcode' | translate }}"
                          (click)="openCamera()"
                        >
                          <i class="bx bx-barcode-reader"></i>
                        </button>
                      </div>
                      <div class="col-xxl-1 col-xl-6 col-1 p-0">
                        <button
                          id="openBarcodeModal"
                          class="btn btn-outline-primary w-100 px-0"
                          type="button"
                          ngbTooltip="{{ 'BarcodeList' | translate }}"
                          (click)="openModal(ScanBarcodeModal)"
                        >
                          <i class="fa-solid fa-qrcode"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                  <app-search-box
                    [data]="searchData"
                    [addButton]="true"
                    [fields]="searchFields"
                    [urlName]="'columnsArray_BuySearch'"
                    [paging]="searchPaging"
                    [modalIsOpen]="modalIsOpen"
                    (parentAction)="parentSearchAction($event)"
                  ></app-search-box>
                </div>
                <!-- 
                <button
                  class="btn btn-primary position-barcode"
                  ngbTooltip="{{ 'ScanBarcode' | translate }}"
                  (click)="openModal(ScanBarcodeModal)"
                >
                  <i class="fa-solid fa-qrcode"></i>
                </button>
                 -->
              </div>
              <div class="col-12 mb-3">
                <div class="edit-form row drugcount-status">
                  <div class="col-3 p-2">
                    <label class="form-label" for="Number">
                      {{ "packageCount" | translate }}
                    </label>
                    <input
                      #count
                      id="packageCount"
                      type="text"
                      autocomplete="off"
                      appSelectOnFocus
                      class="form-control input-one Focusable iner-Focusable"
                      [(ngModel)]="editableItem.packageCount"
                      appConvertNumbers
                      (keyup)="packageKeyUp()"
                      (ngModelChange)="setOnStockCount()"
                      mask="separator.0"
                      thousandSeparator=","
                      [ngClass]="{
                        'is-invalid':
                          editableItemMessage.count != '' &&
                          editableItemMessage.count != null
                      }"
                    />
                  </div>
                  <div
                    class="col-1 h-auto d-flex align-items-end justify-content-center p-0 pb-2"
                  >
                    <label class="form-label label-one">
                      <i class="fa-solid fa-xmark"></i>
                    </label>
                  </div>
                  <div class="col-4 p-2">
                    <label class="form-label" for="Number">
                      {{ "drugPackage" | translate }}
                    </label>
                    <input
                      id="DrugPackage"
                      type="text"
                      appSelectOnFocus
                      appConvertNumbers
                      (keyup)="packageKeyUp()"
                      autocomplete="off"
                      class="form-control input-one Focusable iner-Focusable"
                      [ngClass]="{
                        'is-invalid':
                          editableItemMessage.count != '' &&
                          editableItemMessage.count != null
                      }"
                      [(ngModel)]="editableItem.drugPackageCount"
                      mask="separator.0"
                      thousandSeparator=","
                    />
                  </div>
                  <div
                    class="col-1 h-auto d-flex align-items-end justify-content-center p-0 pb-2"
                  >
                    <label class="form-label label-two col-3">
                      <i class="fa-solid fa-equals"></i>
                    </label>
                  </div>
                  <div class="col-3 p-2">
                    <label class="form-label" for="Number">
                      {{ "Number" | translate }}
                    </label>
                    <input
                      #count
                      id="Number"
                      type="text"
                      autocomplete="off"
                      appConvertNumbers
                      appSelectOnFocus
                      class="form-control Focusable iner-Focusable"
                      [(ngModel)]="editableItem.count"
                      [ngClass]="{
                        'is-invalid':
                          editableItemMessage.count != '' &&
                          editableItemMessage.count != null
                      }"
                      (keyup)="countKeyUp()"
                      mask="separator.0"
                      thousandSeparator=","
                    />

                    <div
                      class="validation-alert-count-sale-buy show-group-validation"
                    >
                      <p>{{ editableItemMessage.count }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-7 p-2 p-xl-1 p-xxl-2 mb-3">
                <div class="edit-form">
                  <div class="validation-alert-sale-buy">
                    <p>{{ editableItemMessage.expireDate }}</p>
                  </div>
                  <label for="expireDate" class="form-label" for="expireDate">
                    {{ "ExpireDate" | translate }}
                  </label>
                  <div class="datepicker-box">
                    <input
                      id="expireDate"
                      type="text"
                      autocomplete="off"
                      appSelectOnFocus
                      appConvertNumbers
                      class="form-control Focusable iner-Focusable"
                      [ngClass]="{
                        'is-invalid':
                          editableItemMessage.expireDate != '' &&
                          editableItemMessage.expireDate != null
                      }"
                      [ngModel]="
                        editableItem.expireDate | dataType : 'justDate' : false
                      "
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="YYYY/MM/DD"
                      (ngModelChange)="
                        editableItem.expireDate = calendarService.TypeDate('expireDate')
                      "
                    />
                    <button
                      [ngbPopover]="popoverDatapickerexpireDate"
                      [autoClose]="'outside'"
                      #datePicker="ngbPopover"
                    >
                      <i class="far fa-calendar-alt"></i>
                    </button>
                  </div>
                  <ng-template #popoverDatapickerexpireDate>
                    <app-data-picker
                      [(childProp)]="editableItem.expireDate"
                      (changeVariableMonth)="changeMonth($event)"
                    ></app-data-picker>
                  </ng-template>
                </div>
              </div>
              <div class="col-12 col-sm-3 p-2 p-xl-1 p-xxl-2 mb-3">
                <div class="edit-form">
                  <label class="form-label" for="lot">
                    {{ "lot-label" | translate }}
                  </label>
                  <input
                    id="lot"
                    type="text"
                    autocomplete="off"
                    [placeholder]="'lot' | translate"
                    appSelectOnFocus
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="editableItem.lot"
                    (keyup.enter)="checkBarcode()"
                  />
                </div>
              </div>
              <div class="col-12 col-sm-2 p-2 p-xl-1 p-xxl-2 mb-3">
                <div class="edit-form">
                  <label class="form-label" for="Lack">
                    {{ "Lack" | translate }}
                  </label>
                  <input
                    id="Lack"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    appConvertNumbers
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="editableItem.lack"
                    (keyup)="lackKeyUp()"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-xl-6 col-xxl-6 col-lg-8 col-md-8 mb-2 padding-mobile-size"
          >
            <div class="row input-box finance-box ms-1 p-2">
              <div class="col-12 col-xxl-6 col-xl-6 col-md-6 mb-3">
                <div class="input-box-title-box px-2">
                  <span>{{ "Finance" | translate : "" }}</span>
                </div>
                <div class="edit-form">
                  <div class="validation-alert-sale-buy">
                    <p>{{ editableItemMessage.buyPrice }}</p>
                  </div>
                  <label class="form-label label-size" for="buyPrice">
                    {{ "buyPrice" | translate }}
                  </label>
                  <input
                    id="buyPrice"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    appConvertNumbers
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="editableItem.buyPrice"
                    [ngClass]="{
                      'is-invalid':
                        editableItemMessage.buyPrice != '' &&
                        editableItemMessage.buyPrice != null
                    }"
                    (keyup)="factor()"
                    mask="separator.0"
                    thousandSeparator=","
                  />

                  <span class="set-position-rial-prefix">
                    {{ "Rial" | translate }}
                  </span>
                </div>
              </div>
              <div class="col-12 col-xxl-6 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <div class="validation-alert-sale-buy">
                    <p>{{ editableItemMessage.sellPrice }}</p>
                  </div>
                  <label class="form-label label-size" for="sellPriceSell">
                    {{ "sellPriceSell" | translate }}
                  </label>

                  <input
                    id="sellPriceSell"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    appConvertNumbers
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="editableItem.sellPrice"
                    [ngClass]="{
                      'is-invalid':
                        editableItemMessage.sellPrice != '' &&
                        editableItemMessage.sellPrice != null &&
                        editableItemMessage.sellPrice != undefined
                    }"
                    (ngModelChange)="setOtherSalePrice()"
                    mask="separator.0"
                    thousandSeparator=","
                  />

                  <span class="set-position-rial-prefix">
                    {{ "Rial" | translate }}
                  </span>
                </div>
              </div>
              <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <label class="form-label label-size" for="onlinePrice">
                    {{ "OnlineDiscount" | translate }}
                  </label>
                  <input
                    id="onlineDiscount"
                    type="number"
                    autocomplete="off"
                    appSelectOnFocus
                    appConvertNumbers
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="onlineDiscount"
                    (ngModelChange)="setOtherSalePrice()"
                  />
                </div>
              </div>
              <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <label class="form-label label-size" for="onlinePrice">
                    {{ "OnlinePrice" | translate }}
                  </label>
                  <!-- <div class="validation-alert-sale-buy">
                    <p>
                        {{item.message! | translate }}
                    </p>
                  </div> -->
                  <input
                    id="onlinePrice"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    appConvertNumbers
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="editableItem.onlinePrice"
                    mask="separator.0"
                    thousandSeparator=","
                  />

                  <span class="set-position-rial-prefix">
                    {{ "Rial" | translate }}
                  </span>
                </div>
              </div>
              <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <div class="form-check form-switch p-0">
                    <label class="form-label label-size" for="partnerPrice">
                      {{ "PartnerDiscount" | translate }}
                    </label>
                    <input
                      id="partnerDiscount"
                      type="number"
                      autocomplete="off"
                      appSelectOnFocus
                      appConvertNumbers
                      class="form-control Focusable iner-Focusable"
                      [(ngModel)]="partnerDiscount"
                      (ngModelChange)="setOtherSalePrice()"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <div class="form-check form-switch p-0">
                    <label class="form-label label-size" for="partnerPrice">
                      {{ "PartnerPrice" | translate }}
                    </label>
                    <input
                      id="partnerPrice"
                      type="text"
                      autocomplete="off"
                      appSelectOnFocus
                      appConvertNumbers
                      class="form-control Focusable iner-Focusable"
                      [(ngModel)]="editableItem.partnerPrice"
                      mask="separator.0"
                      thousandSeparator=","
                    />
                  </div>
                  <span class="set-position-rial-prefix">
                    {{ "Rial" | translate }}
                  </span>
                </div>
              </div>

              <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <div class="form-check form-switch p-0">
                    <label class="form-label" for="buyDiscount">
                      {{ "DiscountAmount" | translate }}
                    </label>
                  </div>
                  <input
                    id="buyCashDiscount"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    appConvertNumbers
                    class="form-control set-input Focusable iner-Focusable"
                    [(ngModel)]="editableItem.buyDiscount"
                    (keypress)="validateInput($event)"
                    (keyup)="calcDiscount('Cash')"
                    mask="separator.0"
                    thousandSeparator=","
                  />

                  <span class="set-position-rial-prefix">
                    {{ "Rial" | translate }}
                  </span>
                </div>
              </div>
              <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <div class="form-check form-switch p-0">
                    <label class="form-label" for="buyDiscount">
                      {{ "DiscountPercent" | translate }}
                    </label>
                    <input
                      id="buyDiscount"
                      type="text"
                      autocomplete="off"
                      appSelectOnFocus
                      appConvertNumbers
                      class="form-control set-input Focusable iner-Focusable"
                      [(ngModel)]="editableItem.buyDiscountPersent"
                      (keyup)="calcDiscount('Percent')"
                      mask="separator.0"
                      thousandSeparator=","
                    />
                  </div>
                  <span class="set-position-rial-prefix">%</span>
                </div>
              </div>
              <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <div class="form-check form-switch p-0">
                    <label class="form-label" for="buyDiscount">
                      {{ "Award" | translate }}
                    </label>
                    <input
                      type="number"
                      id="Award"
                      autocomplete="off"
                      appSelectOnFocus
                      appConvertNumbers
                      class="form-control set-input Focusable iner-Focusable"
                      [(ngModel)]="editableItem.buyGift"
                      (keyup)="setOnStockCount()"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="col-12 col-xxl-4 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <label class="form-label" for="minimumDigitalCount">
                    {{ "minimumDigitalCount" | translate }}
                  </label>
                  <input
                    id="minimumDigitalCount"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="editableItem.minimumDigitalCount"
                    (keyup)="
                      editableItem.minimumDigitalCount =
                        numericService.checkMinAndMaxNumber(
                          0,
                          editableItem.packageCount,
                          editableItem.minimumDigitalCount
                        )
                    "
                    mask="separator.0"
                    thousandSeparator=","
                  />
                </div>
              </div> -->
              <!-- <div class="col-12 col-xxl-4 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <label class="form-label" for="minimumCount">
                    {{ "minimumCount" | translate }}
                  </label>
                  <div class="validation-alert-mincount-sale-buy">
                    <p>{{ editableItemMessage.minimumCount }}</p>
                  </div>
                  <input
                    id="minimumCount"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="editableItem.minimumCount"
                    [ngClass]="{
                      'is-invalid':
                        editableItemMessage.minimumCount != '' &&
                        editableItemMessage.minimumCount != null
                    }"
                    (keyup)="
                      editableItem.minimumCount =
                        numericService.checkMinAndMaxNumber(
                          0,
                          editableItem.packageCount,
                          editableItem.minimumCount
                        )
                    "
                    mask="separator.0"
                    thousandSeparator=","
                  />
                </div>
              </div> -->
              <div class="col-12 col-xxl-3 col-xl-6 col-md-6 mb-3">
                <div class="edit-form">
                  <label class="form-label" for="tax">
                    {{ "Tax" | translate }}
                  </label>
                  <input
                    id="tax"
                    type="text"
                    autocomplete="off"
                    appSelectOnFocus
                    appConvertNumbers
                    class="form-control Focusable iner-Focusable"
                    [(ngModel)]="editableItem.tax"
                    [ngClass]="{
                      'is-invalid':
                        editableItemMessage.Tax != '' &&
                        editableItemMessage.Tax != null
                    }"
                    (keyup)="factor()"
                    mask="separator.0"
                    thousandSeparator=","
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-lg-4 col-md-4 mb-2">
            <div class="row input-box stock-box mx-1 p-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="input-box-title-box px-2">
                      <span>{{ "Stock" | translate : "" }}</span>
                    </div>
                    <div
                      class="record-item d-flex mt-1 p-2"
                      *ngFor="let item of editableItem.stocks; let i = index"
                    >
                      <span class="mx-1">{{ item.count }}</span>
                      <span class="mx-1">{{
                        "itemCountIn" | translate : ""
                      }}</span>
                      <span class="mx-1">{{ item.stockName }}</span>
                      <button
                        type="button"
                        class="stock-close"
                        (click)="removeStock(i)"
                      >
                        <i class="bx bx-x"></i>
                      </button>
                    </div>
                  </div>
                  <ng-container
                    *ngIf="
                      editableItem.lack != null &&
                        editableItem.packageCount != null &&
                        editableItem.lack == editableItem.packageCount;
                      else normalStock
                    "
                  >
                    <div class="col-12">
                      <p>{{ "Don'tNeedBuyStock" | translate }}</p>
                    </div>
                  </ng-container>
                  <ng-template #normalStock>
                    <ng-container *ngIf="stockHelpItem.isActive; else noCount">
                      <div class="col-12">
                        <div class="edit-form">
                          <div
                            class="validation-alert-sale-buy hide-group-validation"
                          >
                            <p>{{ editableItemMessage.stockId }}</p>
                          </div>
                          <label class="form-label label-size" for="count">
                            {{ "count" | translate }}
                          </label>
                          <input
                            class="form-control Focusable iner-Focusable"
                            [ngClass]="{
                              'is-invalid':
                                editableItemMessage.stockId != '' &&
                                editableItemMessage.stockId != null
                            }"
                            type="text"
                            autocomplete="off"
                            appSelectOnFocus
                            appConvertNumbers
                            id="stockCount"
                            [attr.disabled]=""
                            [(ngModel)]="newItem.count"
                            mask="separator.0"
                            thousandSeparator=","
                          />
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="edit-form">
                          <div
                            class="validation-alert-sale-buy show-group-validation"
                          >
                            <p>{{ editableItemMessage.stockId }}</p>
                          </div>
                          <label class="form-label label-size" for="stockName">
                            {{ "stockName" | translate }}
                          </label>
                          <select
                            id="stockName"
                            class="form-select input-select-text py-2 Focusable iner-Focusable"
                            [(ngModel)]="newItem.stockId"
                            [ngClass]="{
                              'is-invalid':
                                editableItemMessage.stockId != '' &&
                                editableItemMessage.stockId != null
                            }"
                            (change)="nextFocus()"
                          >
                            <option Value="">
                              {{ "SelectOne" | translate }}
                            </option>
                            <option
                              *ngFor="let stock of stockList"
                              [ngValue]="stock.id"
                            >
                              {{ stock.persianName }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-12 d-flex justify-content-center mt-2">
                        <button
                          class="btn btn-primary Focusable iner-Focusable mt-3"
                          (click)="addStock()"
                        >
                          <i class="fas fa-plus"></i>
                          {{ "ADD" | translate }}
                        </button>
                      </div>
                    </ng-container>
                    <ng-template #noCount>
                      <div class="col-12" *ngIf="stockHelpItem.maxCount == 0">
                        <p>{{ "PleaseInputCount" | translate }}</p>
                      </div>
                    </ng-template>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <hr />
          </div>
          <div class="col-12 mb-3 d-flex justify-content-between">
            <button
              type="button"
              id="save-button"
              class="btn btn-primary Focusable iner-Focusable"
              (click)="confirmItem()"
            >
              <i class="far fa-save"></i>
              {{ "Save" | translate }}
            </button>
            <button
              type="button"
              id="clear-button"
              class="btn btn-light ms-2 Focusable iner-Focusable"
              (click)="clearEditItem()"
            >
              <i class="fas fa-eraser"></i>
              {{ "Clear" | translate }}
            </button>
          </div>
        </div>
      </div>
      <app-loading-panel *ngIf="loading"></app-loading-panel>
    </div>
  </div>
</div>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<ng-template #CashAddModal let-modal class="modal modal-top fade">
  <app-cash-pay
    [thisItem]="cashThisItem"
    (parentActionOutput)="parentAction($event)"
  ></app-cash-pay>
</ng-template>

<ng-template #CashMultiPayment let-modal class="modal modal-top fade">
  <app-cash-multi-payment
    [thisItem]="cashThisItem"
    (parentActionOutput)="parentAction($event)"
  >
  </app-cash-multi-payment>
</ng-template>

<ng-template #CreditMultiPayment let-modal class="modal modal-top fade">
  <app-credit-multi-payment
    [thisItem]="creditThisItem"
    (parentActionOutput)="parentAction($event)"
  >
  </app-credit-multi-payment>
</ng-template>

<ng-template #CreditAddModal let-modal class="modal modal-top fade">
  <app-credit-pay
    [thisItem]="creditThisItem"
    (parentActionOutput)="parentAction($event)"
  ></app-credit-pay>
</ng-template>

<ng-template #ScanBarcodeModal let-modal class="modal modal-top fade">
  <app-scan-barcode-modal
    [itemCount]="editableItem.packageCount"
    [barcodeList]="editableItem.drugUIds"
    (parentActionOutput)="parentAction($event)"
  ></app-scan-barcode-modal>
</ng-template>

<app-pcconfrim-modal
  *ngIf="confirmModalOpen"
  [inputModel]="modalConfirm"
  (childEvent)="parentAction($event)"
></app-pcconfrim-modal>

<ng-template #addDrug let-modal class="modal-width">
  <app-drug-modal
    [activeAddModal]="true"
    [thisValue]="thisValue"
    (parentAction)="parentAction($event)"
  >
  </app-drug-modal>
</ng-template>

<app-pcsetting-modal
  (parentAction)="parentAction($event)"
  [fields]="searchFields"
>
</app-pcsetting-modal>

<app-barcode-scanner
  #barcodeScanner
  (parentAction)="handleScannedBarcode($event)"
></app-barcode-scanner>
